import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-trial-expired-dialog',
  standalone: true,
  imports: [NgOptimizedImage, TranslocoPipe],
  template: `
    <div class="flex flex-col items-center justify-center p-0 lg:flex-row">
      <div class="px-4 py-14 md:px-10 lg:w-3/5 lg:px-14 lg:px-20">
        <h1 class="text-2xl">{{ 'profile.subscription.deviceUser.expired.title' | transloco }}</h1>
        <p class="mt-8">
          {{ 'profile.subscription.deviceUser.expired.content' | transloco }}
        </p>
        <p class="mt-4">{{ 'profile.subscription.deviceUser.expired.content2' | transloco }}</p>
      </div>
      <div class="order-first flex justify-center overflow-hidden max-lg:max-h-[40vh] lg:order-last lg:w-2/5">
        <img
          alt="Qira"
          ngSrc="assets/images/qira_on_tablet_2.jpg"
          width="1000"
          height="563"
          priority
          class="aspect-square w-full object-cover object-right" />
      </div>
    </div>
  `,
  styles: [],
})
export class TrialExpiredDialogComponent {}
